import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/inbox-settings',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/InboxSettingsContainer',
      './modules/inboxSettings'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const InboxSettings = require('./containers/InboxSettingsContainer').default
      const actions = require('./modules/inboxSettings')
      const reducer = require('./modules/inboxSettings').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'inboxSettings', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, InboxSettings)

    /* Webpack named bundle   */
    }, 'inboxSettings')
  }
})


// WEBPACK FOOTER //
// ./src/routes/InboxSettings/index.js